var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        visible: _vm.visible,
        width: "1200px",
        top: "8vh",
        "show-close": false,
        "close-on-click-modal": false,
        "append-to-body": "",
        "custom-class": "update-statement-dialog",
      },
      on: {
        "update:visible": function ($event) {
          _vm.visible = $event
        },
        closed: _vm.handleClosed,
      },
    },
    [
      _c("div", { staticClass: "statement-update-wrap" }, [
        _c("div", { staticClass: "statement-summary" }, [
          _c("span", [
            _vm._v("商家类型："),
            _c("b", [
              _vm._v(_vm._s(_vm.merchantTypeText(_vm.statement.merchantType))),
            ]),
          ]),
          _vm._v(" "),
          _c("span", [
            _vm._v("商家名称："),
            _c("b", [_vm._v(_vm._s(_vm.statement.merchantName || "-"))]),
          ]),
          _vm._v(" "),
          _c("span", [
            _vm._v("对账单号："),
            _c("b", [_vm._v(_vm._s(_vm.statement.statementNo || "-"))]),
          ]),
          _vm._v(" "),
          _c("span", [
            _vm._v("账单周期："),
            _c("b", [_vm._v(_vm._s(_vm.periodText))]),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "update-tips" }, [
          _c("div", [
            _vm._v(
              "说明：1. 当前只支持更新：实际结算-商品、实际结算-运费、实际结算-打包费；"
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "tip-indent" }, [
            _vm._v(
              "2. 导入的模板是在总订单导出的excel文件基础上删除从【客户供货价】到【支付方式】的列，并删除第一行表头。"
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "tip-indent" }, [
            _vm._v(
              '3. 导入模板"订单详情ID"和"实际结算-商品"需要保持一致(都合并单元格或都不合并单元格)。'
            ),
          ]),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "update-actions" },
          [
            _c(
              "div",
              { staticClass: "import-action" },
              [
                _c(
                  "el-upload",
                  {
                    attrs: {
                      action: "#",
                      accept: ".xlsx,.xls",
                      "show-file-list": false,
                      disabled: _vm.importLoading,
                      "before-upload": _vm.beforeUpload,
                      "http-request": _vm.handleImportRequest,
                    },
                  },
                  [
                    _c(
                      "el-button",
                      {
                        staticClass: "action-button",
                        attrs: { type: "primary", loading: _vm.importLoading },
                      },
                      [_vm._v("导入数据")]
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _vm.excelFile
                  ? _c("div", { staticClass: "import-file" }, [
                      _c("i", { staticClass: "el-icon-document" }),
                      _vm._v(" "),
                      _c("span", [_vm._v(_vm._s(_vm.excelFile.name))]),
                    ])
                  : _vm._e(),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "el-button",
              {
                staticClass: "action-button template-button",
                attrs: { type: "success" },
                on: { click: _vm.handleDownloadTemplate },
              },
              [_vm._v("下载模板")]
            ),
          ],
          1
        ),
        _vm._v(" "),
        _vm.confirmInfo
          ? _c("div", { staticClass: "confirm-box" }, [
              _c("div", { staticClass: "confirm-title" }, [
                _vm._v("确认导入信息"),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "confirm-content" }, [
                _c("div", { staticClass: "summary-list" }, [
                  _c("div", { staticClass: "summary-item" }, [
                    _c("span", [_vm._v("有效订单数量：")]),
                    _vm._v(" "),
                    _c("b", [
                      _vm._v(
                        _vm._s(
                          _vm.formatConfirmValue(
                            _vm.confirmInfo.validOrderCount
                          )
                        )
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "summary-item" }, [
                    _c("span", [_vm._v("总实际结算-商品：")]),
                    _vm._v(" "),
                    _c("b", [
                      _vm._v(
                        "￥" +
                          _vm._s(
                            _vm.formatConfirmValue(
                              _vm.confirmInfo.productAmount
                            )
                          )
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "summary-item" }, [
                    _c("span", [_vm._v("总实际结算-运费：")]),
                    _vm._v(" "),
                    _c("b", [
                      _vm._v(
                        "￥" +
                          _vm._s(
                            _vm.formatConfirmValue(
                              _vm.confirmInfo.freightAmount
                            )
                          )
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "summary-item" }, [
                    _c("span", [_vm._v("总实际结算-打包费：")]),
                    _vm._v(" "),
                    _c("b", [
                      _vm._v(
                        "￥" +
                          _vm._s(
                            _vm.formatConfirmValue(
                              _vm.confirmInfo.packingFeeAmount
                            )
                          )
                      ),
                    ]),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "invalid-list" }, [
                  _c("span", [_vm._v("不属于当前对账单中的订单：")]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "invalid-orders" },
                    [
                      _vm.confirmInvalidOrderNos.length
                        ? _vm._l(
                            _vm.confirmInvalidOrderNos,
                            function (orderNo) {
                              return _c("div", { key: orderNo }, [
                                _vm._v(_vm._s(orderNo)),
                              ])
                            }
                          )
                        : _c("span"),
                    ],
                    2
                  ),
                ]),
              ]),
            ])
          : _c("div", { staticClass: "confirm-box confirm-empty" }, [
              _vm._v("请先导入 Excel 文件，系统解析后会展示确认导入信息。"),
            ]),
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c(
            "el-button",
            {
              attrs: { size: "small" },
              on: {
                click: function ($event) {
                  _vm.visible = false
                },
              },
            },
            [_vm._v("取消")]
          ),
          _vm._v(" "),
          _c(
            "el-button",
            {
              staticClass: "confirm-update-button",
              attrs: {
                size: "small",
                type: "primary",
                disabled: !_vm.confirmInfo || _vm.importLoading,
                loading: _vm.submitLoading,
              },
              on: { click: _vm.debouncedSubmit },
            },
            [_vm._v("确定更新")]
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }